import { render, staticRenderFns } from "./psychologicalTest.vue?vue&type=template&id=c36601e8&scoped=true&"
import script from "./psychologicalTest.vue?vue&type=script&lang=js&"
export * from "./psychologicalTest.vue?vue&type=script&lang=js&"
import style0 from "./psychologicalTest.vue?vue&type=style&index=0&id=c36601e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36601e8",
  null
  
)

export default component.exports